class CookieBar {
    constructor() {
        this.bar = document.getElementById('cookie-bar');
        if (!this.bar) return;

        this.preferencesPanel = this.bar.querySelector('.cookie-bar__preferences');
        this.mainPanel = this.bar.querySelector('.cookie-bar__main');

        this.init();
    }

    init() {

        if (localStorage.getItem('consent_given') === null) {
            this.showBar();
        }

        // Link/przycisk "Zmień ustawienia cookies" (np. w Polityce cookies): ponowne otwarcie panelu preferencji
        this.onSettingsClick = (e) => {
            const trigger = e.target.closest('[data-cookie-settings], a[href="#ustawienia-cookies"]');
            if (!trigger) return;
            e.preventDefault();
            e.stopPropagation();
            this.showBar();
            this.togglePreferences(true);
        };
        document.addEventListener('click', this.onSettingsClick, true);

        this.bar.addEventListener('click', (e) => {
            const button = e.target.closest('button[data-consent]');
            if (button) {
                this.handleConsent(button.dataset.consent);
                return;
            }

            const manageBtn = e.target.closest('button[data-action="manage"]');
            if (manageBtn) {
                this.togglePreferences(true);
                return;
            }

            const backBtn = e.target.closest('button[data-action="back"]');
            if (backBtn) {
                this.togglePreferences(false);
                return;
            }

            const saveBtn = e.target.closest('button[data-action="save"]');
            if (saveBtn) {
                this.savePreferences();
            }
        });
    }

    destroy() {
        document.removeEventListener('click', this.onSettingsClick, true);
    }

    showBar() {
        this.bar.style.display = 'block';

        requestAnimationFrame(() => {
            this.bar.classList.add('is-visible');
        });
    }

    hideBar() {
        this.bar.classList.remove('is-visible');
        setTimeout(() => {
            this.bar.style.display = 'none';
        }, 400);
    }

    togglePreferences(show) {
        if (show) {
            const analyticsEl = document.getElementById('consent-analytics');
            const marketingEl = document.getElementById('consent-marketing');

            if (analyticsEl) {
                analyticsEl.checked = localStorage.getItem('consent_analytics') === 'true';
            }
            if (marketingEl) {
                marketingEl.checked = localStorage.getItem('consent_marketing') === 'true';
            }

            this.mainPanel.style.display = 'none';
            this.preferencesPanel.style.display = 'flex';
        } else {
            this.preferencesPanel.style.display = 'none';
            this.mainPanel.style.display = 'flex';
        }
    }

    updateGtag(analytics, marketing) {
        if (typeof window.gtag === 'function') {
            window.gtag('consent', 'update', {
                'analytics_storage': analytics ? 'granted' : 'denied',
                'ad_storage': marketing ? 'granted' : 'denied',
                'ad_user_data': marketing ? 'granted' : 'denied',
                'ad_personalization': marketing ? 'granted' : 'denied'
            });
        }
    }

    handleConsent(action) {
        this.hideBar();

        if (action === 'accept') {
            this.updateGtag(true, true);
            localStorage.setItem('consent_given', 'true');
            localStorage.setItem('consent_analytics', 'true');
            localStorage.setItem('consent_marketing', 'true');
        } else {
            this.updateGtag(false, false);
            localStorage.setItem('consent_given', 'false');
            localStorage.setItem('consent_analytics', 'false');
            localStorage.setItem('consent_marketing', 'false');
        }
    }

    savePreferences() {
        const analyticsEl = document.getElementById('consent-analytics');
        const marketingEl = document.getElementById('consent-marketing');

        const analytics = analyticsEl ? analyticsEl.checked : false;
        const marketing = marketingEl ? marketingEl.checked : false;

        this.hideBar();
        this.updateGtag(analytics, marketing);

        localStorage.setItem('consent_given', 'custom');
        localStorage.setItem('consent_analytics', analytics ? 'true' : 'false');
        localStorage.setItem('consent_marketing', marketing ? 'true' : 'false');
    }
}

export default CookieBar;